import React from 'react';
import useFormDataLayer from '../logic/useFormDataLayer';
import useFormLayout from '../layout/useFormLayout';
import FormRepeating from './FormRepeating';

var ConnectedRepeating = function ConnectedRepeating(_ref) {
  var fieldId = _ref.fieldId;
  var fieldData = useFormDataLayer(fieldId);
  var layout = useFormLayout();
  var values = fieldData.value,
      dispatch = fieldData.dispatch,
      error = fieldData.error;
  var caption = fieldData.caption,
      readonly = fieldData.readonly,
      collapsed = fieldData.collapsed,
      addBtnContent = fieldData.addBtnContent;
  var items = values && values.map(function (value) {
    var suffix = "_".concat(value);
    var container = layout.containers["".concat(fieldId).concat(suffix)];
    return {
      value: value,
      container: container
    };
  });
  return React.createElement(FormRepeating, {
    fieldId: fieldId,
    items: items,
    dispatch: dispatch,
    caption: caption,
    collapsed: collapsed,
    error: error,
    readonly: readonly,
    addBtnContent: addBtnContent
  });
};

export default ConnectedRepeating;